import { apiClient } from '../../../shared/services/apiClient';
import { ActiveSession } from '../types/sessionLogs.types';

interface SessionsResponse {
    sessions: ActiveSession[];
    total: number;
    page: number;
    pages: number;
}

export const fetchActiveSessions = async (
    page = 1,
    limit = 50
): Promise<SessionsResponse> => {
    const { data } = await apiClient.get<SessionsResponse>(
        '/super-admin/sessions',
        { params: { page, limit } }
    );
    return data;
};
